import * as React from "react";
import classNames from "classnames";

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const FormInputHelp = ({ className, children, ...props }: Props) => {
  if (!children) {
    return null;
  }

  return (
    <p className={classNames("dark-gray mb-0 mt-1 p-0", className)} {...props}>
      {children}
    </p>
  );
};

export default FormInputHelp;
